import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=21e826bc&scoped=true"
import script from "./Manual.vue?vue&type=script&lang=js"
export * from "./Manual.vue?vue&type=script&lang=js"
import style0 from "./Manual.vue?vue&type=style&index=0&id=21e826bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e826bc",
  null
  
)

export default component.exports